import { HeaderMenuData } from '@ep/types/menuData';
import React, { useRef, useState } from 'react';
import Collapsible from '../Collapsible';
import SubNavItem, { SubNavItemState } from './SubNavItem';

export interface SubNavProps {
  data: HeaderMenuData;
  hoveredNavItemIndex?: number;
  navCollapsed: boolean;
}

function SubNav({ data, hoveredNavItemIndex, navCollapsed }: SubNavProps) {
  const [isHover, setIsHover] = useState<boolean>(false);
  const lastHoveredIndexRef = useRef<number>();

  if (hoveredNavItemIndex !== undefined) {
    lastHoveredIndexRef.current = hoveredNavItemIndex;
  } else if (!isHover) {
    lastHoveredIndexRef.current = undefined;
  }

  const hoveredIndex = lastHoveredIndexRef.current;
  const hoveredNavItem =
    hoveredIndex !== undefined ? data[hoveredIndex] : undefined;
  const hoveredSubmenu = hoveredNavItem?.submenu;

  return (
    <Collapsible
      height={hoveredNavItem?.sidemenu ? '33rem' : '18rem'}
      collapsed={navCollapsed || !hoveredSubmenu}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {data.map((navItem, index) => {
        if (!navItem.submenu) {
          return null;
        }

        let state;
        if (hoveredIndex === undefined || index > hoveredIndex) {
          state = SubNavItemState.next;
        } else if (index === hoveredIndex) {
          state = SubNavItemState.current;
        } else {
          state = SubNavItemState.previous;
        }

        return (
          <SubNavItem key={navItem.label} navItem={navItem} state={state} />
        );
      })}
    </Collapsible>
  );
}

export default React.memo(SubNav);
